import 'classlist-polyfill'
import 'intersection-observer'
import Vue from 'vue'
import vuetify from './plugins/vuetify'
import VueScrollTo from 'vue-scrollto'
import VueLazyload from 'vue-lazyload'
import App from './App.vue'

Vue.use(VueScrollTo, {
  offset: -20
})

Vue.use(VueLazyload, {
  lazyComponent: true
})

Vue.config.productionTip = false

fetch( process.env.BASE_URL + "config.json" ).then( resp => resp.json() ).then( config => { 
  Vue.prototype.$config = config
  new Vue({
    vuetify,
    render: (h) => h(App)
  }).$mount("#app")  
})
